// 设置 rem 函数
function setRem() {
    // 1920 默认大小37.5px; 1920px = 120rem ;每个元素px基础上/37.5
    // 750屏幕下：1rem = 20px
    const screenWidth = 750
    const scale = screenWidth / 20
    const htmlWidth = document.documentElement.clientWidth || document.body.clientWidth
    // 得到html的Dom元素
    const htmlDom = document.getElementsByTagName('html')[0]
    // 设置根元素字体大小
    htmlDom.style.fontSize = htmlWidth / scale + 'px'
    //  htmlDom.style.fontSize = (document.documentElement.clientWidth / 750) * 37.5;
}
// 初始化
setRem()
// 改变窗口大小时重新设置 rem
window.onresize = function () {
    setRem()
}

